// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* dynamic-second-level-nav.component.css */

.learmo-nav-link {
  color: var(--bs-text-gray-700) !important;
  font-weight: 500 !important;
  text-wrap: nowrap;
}

.learmo-nav-link.active {
  color: var(--bs-text-primary) !important;
  font-weight: 500 !important;

}


.learmo-nav-link .item-label {
  opacity: 0.7;
  transition: all 0.05s ease-in-out;
}

.learmo-nav-link:hover .item-label, .learmo-nav-link.active .item-label {
  opacity: 1;
  transition: all 0.15s ease-in-out;

}

.learmo-nav-link.active {
  /* background-color: var(--bs-primary-light); */
}
/* .learmo-nav-link.active .item-label {
  transform: scale(1.15) !important;
}
.learmo-nav-link:hover .item-label {
  transform: scale(1.10) !important;
} */




/*
@media (max-width: 1212px) and (min-width:992px) {
  #learmo-main-menu {
    flex-direction: column;
    align-items: flex-start;

  }
  .learmo-nav-link {
    width: 100%;
    padding-top: 5px;
  }
  .nav-item {
    margin-bottom: 10px;
  }
} */
/* @media (min-width: 768px) {
  #learmo-main-menu {
    flex-direction: row;
  }
  .nav-item {
    margin-bottom: 0;
  }
} */

/* @media (max-width: 768px) {
  #learmo-sub-menu .nav {
    flex-direction: column;
    align-items: stretch;
  }
  #learmo-sub-menu .nav-link {
    width: 100%;
    text-align: center;
  }
} */
/*
@media (min-width: 769px) {
  #learmo-sub-menu .nav {
    flex-direction: row;
  }
} */


/* Sub Menu Animation */

@keyframes animationLearmoSlideIn {
  from {
    transform: translate3d(0, -50%, 0);
    opacity: 0;
    visibility: visible;
  }
  to {
      opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}


.animation-learmo-slide-in {
  animation-name: animationLearmoSlideIn;
}


#learmo-sub-menu {
  transition: all 0.3s ease-in-out;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/dynamic-second-level-nav/dynamic-second-level-nav.component.css"],"names":[],"mappings":";AACA,2CAA2C;;AAE3C;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;;AAE7B;;;AAGA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;;AAEnC;;AAEA;EACE,+CAA+C;AACjD;AACA;;;;;GAKG;;;;;AAKH;;;;;;;;;;;;;;GAcG;AACH;;;;;;;GAOG;;AAEH;;;;;;;;;GASG;AACH;;;;;GAKG;;;AAGH,uBAAuB;;AAEvB;EACE;IACE,kCAAkC;IAClC,UAAU;IACV,mBAAmB;EACrB;EACA;MACI,UAAU;IACZ,+BAA+B;EACjC;AACF;;;AAGA;EACE,sCAAsC;AACxC;;;AAGA;EACE,gCAAgC;AAClC;;AAEA,wwGAAwwG","sourcesContent":["\n/* dynamic-second-level-nav.component.css */\n\n.learmo-nav-link {\n  color: var(--bs-text-gray-700) !important;\n  font-weight: 500 !important;\n  text-wrap: nowrap;\n}\n\n.learmo-nav-link.active {\n  color: var(--bs-text-primary) !important;\n  font-weight: 500 !important;\n\n}\n\n\n.learmo-nav-link .item-label {\n  opacity: 0.7;\n  transition: all 0.05s ease-in-out;\n}\n\n.learmo-nav-link:hover .item-label, .learmo-nav-link.active .item-label {\n  opacity: 1;\n  transition: all 0.15s ease-in-out;\n\n}\n\n.learmo-nav-link.active {\n  /* background-color: var(--bs-primary-light); */\n}\n/* .learmo-nav-link.active .item-label {\n  transform: scale(1.15) !important;\n}\n.learmo-nav-link:hover .item-label {\n  transform: scale(1.10) !important;\n} */\n\n\n\n\n/*\n@media (max-width: 1212px) and (min-width:992px) {\n  #learmo-main-menu {\n    flex-direction: column;\n    align-items: flex-start;\n\n  }\n  .learmo-nav-link {\n    width: 100%;\n    padding-top: 5px;\n  }\n  .nav-item {\n    margin-bottom: 10px;\n  }\n} */\n/* @media (min-width: 768px) {\n  #learmo-main-menu {\n    flex-direction: row;\n  }\n  .nav-item {\n    margin-bottom: 0;\n  }\n} */\n\n/* @media (max-width: 768px) {\n  #learmo-sub-menu .nav {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  #learmo-sub-menu .nav-link {\n    width: 100%;\n    text-align: center;\n  }\n} */\n/*\n@media (min-width: 769px) {\n  #learmo-sub-menu .nav {\n    flex-direction: row;\n  }\n} */\n\n\n/* Sub Menu Animation */\n\n@keyframes animationLearmoSlideIn {\n  from {\n    transform: translate3d(0, -50%, 0);\n    opacity: 0;\n    visibility: visible;\n  }\n  to {\n      opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n\n.animation-learmo-slide-in {\n  animation-name: animationLearmoSlideIn;\n}\n\n\n#learmo-sub-menu {\n  transition: all 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
